<template>
  <div class="panel cc-panel-default">
    <template  v-if="!this.memo.id" class="media">
      <div class="media-body media-right text-right">
        <button
          v-show="idUser == 0"
          title="Neuer Eintrag"
          type="button" class="btn btn-link" 
          @click="editModus = 'dienst'"><span>Neuer Dienst</span>
        </button>
        <button
          v-show="1"
          title="Neuer Eintrag"
          type="button" class="btn btn-link" 
          @click="editModus = 'absence'"><span>Neue Abwesenheit</span>
        </button>
        <button 
          title="Neuer Eintrag"
          type="button" class="btn btn-link" 
          @click="editModus = 'edit'"><span>Neue Vorgabe</span>
        </button>
      </div>
    </template >
    
    <template v-else class="">

      <div class="panel-heading media" role="tab" :id="headingID">
        
        <p class="panel-title media-body media-middle" >
          <a role="button" 
            style="display: inline-block; width:100%; padding: 6px 0px 6px 0px"
            data-toggle="collapse" 
            :data-parent="'#' + data_parent"
            :href="'#' + collapsID" 
            aria-expanded="true" 
            :aria-controls="collapsID">
            <i class="fa  fa-lg"
              :class="MemoConf.TYP[memo.typ].SYMBOL.CLASS"
              :title="MemoConf.TYP[memo.typ].SYMBOL.TITLE" 
              aria-hidden="true">
            </i>
            <b>{{headline}}</b> - <small> {{memo.summary}}</small>
          </a>
        </p>

        <div class="media-right text-right media-middle" style="white-space: nowrap;">
          <a role="button" 
            data-toggle="collapse" 
            :data-parent="'#' + data_parent"
            :href="'#' + collapsID" 
            aria-expanded="true" 
            :aria-controls="collapsID">
            <span v-show="memo.text">
              <i v-show="isCollapseIn == false" class="fa fa-expand" aria-hidden="true"></i>
              <i v-show="isCollapseIn == true" class="fa fa-compress " aria-hidden="true"></i>
            </span>
          </a>
          <button type="button"
                  title="Eintrag bearbeiten"
                  class="btn  btn-link cc-btn-menue"
                  v-on:click="editModus = 'edit'">
                  <span class="glyphicon glyphicon-option-vertical"></span>
          </button>
        </div>
        
      </div>
      
      
      <div :id="collapsID" 
        class="panel-collapse collapse" 
        :class="{ in: collapseIn }" 
        role="tabpanel" 
        :aria-labelledby="headingID">
        <div class="panel-body">
          <div  v-for="userClient in memo.userClientRef" >
             <a href="#" 
               v-on:click="onHitUserClient(userClient.id)">
               {{userClient.firstName}} {{userClient.lastName}} {{userClient.department}} {{userClient.room}} {{userClient.function}}
             </a> 
          </div>
          <span  v-for="(text, index) in memo.textSplited" v-bind:style="text.style">
             <a href="#" 
               v-if="text.idUserClient > 0" 
               v-on:click="onHitUserClient(text.idUserClient)">
               {{text.text}}
             </a>
             <span v-else v-html="text.text"></span>
          </span>
        </div>
      </div>

    </template >

    <cc-memo-dienst-modal 
      v-if="editModus == 'dienst' " 
      :memo="memo"  
      :idCompany="idCompany"
      :idUser="idUser"
      @cancel="cancel"
      @remove="remove"
      @save="save">
    </cc-memo-dienst-modal>

    <cc-memo-absence-modal 
      v-if="editModus == 'absence' " 
      :memo="memo"  
      :idCompany="idCompany"
      :idUser="idUser"
      @cancel="cancel"
      @remove="remove"
      @save="save">
    </cc-memo-absence-modal>

    <cc-memo-modal 
      v-if="editModus == 'edit' " 
      :memo="memo"  
      :idCompany="idCompany"
      :idUser="idUser"
      @cancel="cancel"
      @remove="remove"
      @save="save">
    </cc-memo-modal>
  </div>
                   
</template>



<script>

import bus from './common/bus'
import moment from 'moment'
import MemoCommon from './common/memo.common'
import MemoModal from './MemoModal.vue'
import MemoAbsenceModal from './MemoAbsenceModal.vue'
import MemoDienstModal from './MemoDienstModal.vue'

export default {

  extends: MemoCommon,

  components: {
    'cc-memo-modal': MemoModal,
    'cc-memo-absence-modal': MemoAbsenceModal,
    'cc-memo-dienst-modal': MemoDienstModal,
  },
  
  data () {
    return {
      collapse:false,
    }
  },
  
  mounted: function () {
    this.collapse = this.collapseIn;
    
    var that = this;
    $('#' + this.collapsID).on('shown.bs.collapse', function () {
      that.collapse = true;
    })
    $('#' + this.collapsID).on('hidden.bs.collapse', function () {
      that.collapse = false;
    })
  },
  
  
  
  computed: {

    collapsID: function () {
      return 'collaps'+this.memo.id;
    },
    
    headingID: function () {
      return 'heading'+this.memo.id;
    },
    
    headline: function () {
        
        let dt_now = moment().format('YYYY-MM-DD HH:mm:ss')
        let dt_unlimited = '2029-12-31 00:00:00'
        let dt_begin = this.memo.datetimeBegin
        let dt_end = this.memo.datetimeEnd

        if( dt_begin < dt_now && dt_end != dt_unlimited )
          return this.memo.headline + ' bis ' + this.getDateTime(dt_end)
        else if ( dt_begin > dt_now && dt_end != dt_unlimited)
          return 'ab ' + this.getDateTime(dt_begin) + ' ' + this.memo.headline + ' bis ' + this.getDateTime(dt_end)
        else if (dt_begin > dt_now && dt_end == dt_unlimited)
          return 'ab ' + this.getDateTime(dt_begin) + ' ' + this.memo.headline
        else
          return this.memo.headline
      
    },
  
    isCollapseIn: function () {
      return this.collapse;
    },

    
  },
  
  
    
  methods: {

    getDateTime: function (dateTime) {
      moment.locale('de');
      let d = new Date(dateTime);
      let d_now = new Date();
      let d_tomorrow =  new Date();
      d_tomorrow.setDate(d_now.getDate() + 1);
      let dateString = '';
      
      
      if(d.toDateString() == d_now.toDateString()){
        dateString = 'Heute, ' + moment(d).format('HH:mm');
      }else if(d.toDateString() == d_tomorrow.toDateString()){
        dateString = 'Morgen, ' + moment(d).format('HH:mm');
      }else{
        dateString = moment(d).format('dd DD.MM, HH:mm');
      }
      
      return dateString;
    },


    onHitUserClient: function (idUserClient) {
      bus.emitIdUserClient(idUserClient);
      //console.log('CompanyClient:hitUserClient: ' + idUserClient);
    },
    
    onInsert: function (memo) {
      this.$emit('insert', memo);
    },
  
    // Overridden 
    onUpdate: function (memo) {
      this.$emit('update', memo);
    },
  
    // Overridden 
    onCancel: function (memo) {
      //this.$emit('cancel', memo);
    },
  
    // Overridden 
    onRemove: function (memo) {
      this.$emit('remove', memo);
    },
    

  }
  
}
</script>



<style scoped>
  
  .panel-group .panel-heading+.panel-collapse>.list-group, .panel-group .panel-heading+.panel-collapse>.panel-body{
    border-top: 0px;
  }  

  
  .panel-body a {
    text-decoration: underline;
    color: purple;
  }
  
  h2 .fa, .panel .fa {
      padding-right: 12px;
      color: #337ab7;
  }
  
  .panel-group .panel+.panel{
    margin: 0px;
  }
  
  .panel-body{
    border-left: 20px solid #fcf8e3;
    background-color: #fcf8e3;
    
  }  
.cc-panel-default {
    border-bottom: 1px solid lightgrey;
    line-height: 1.2;  
}
  
  
.cc-btn-menue{
    padding-left: 5px;  
    padding-right: 0px;  
  }
  
.panel-heading {
    padding: 0px 0px;
}
  

.panel-title{
  font-size: 14px  ;
}

</style>



// WEBPACK FOOTER //
// Memo.vue?d62ed152